import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { BackBtn } from 'components/Shared/Button';
import { parseDate } from 'utils';
import { StepContainer } from './StepContainer';

const SuccessMultiple = ({ contracts = [], handleBack, source, errors = [] }) => {
  const { t } = useTranslation();

  console.log({contracts, errors})
  return (
    <StepContainer
      className="sidebar-new-contract-height"
      title={t('contracts.new.done')}
      src={'/images/listing/createDocument/check.svg'}
      alt={t('common.checkmark')}
      form={
        <div className="text-center">

          <p className="mb-5">
            {t('contracts.new.source_title')}
          </p>

          <h5 className="font-weight-bold mb-3">
            {t('reports.tableHeaders.created')}
          </h5>

          <p className="font-weight-bold mb-3">
            {t(source)}
          </p>
          <p>
            {parseDate(new Date().toISOString(), 'P')}
          </p>

          <hr />
          {
            contracts.map((c) => (
              <Fragment key={c._id}>
                <div className="text-uppercase">{c.name}</div>
                <div className="">
                  <p>{c.type && c.type.name}</p>
                  <p>
                    {/* {c.uploadMethod} */}
                  </p>
                </div>
                <hr />
              </Fragment>
            ))
          }
          {
            errors?.map?.(({ contract = {}, errors = [] } = {}, index) => (
              <Fragment key={`errorc_${index}`}>
                <div className="text-uppercase">{contract.name}</div>
                <div>
                  <p>{contract.type && contract.type.name}</p>
                </div>
                {
                  errors?.map?.((error, index) => (
                    <div className="create-half-half" key={`errore_${index}`}>
                      <p className="d-flex align-items-center justify-content-center">
                        <i className="fas fa-times text-danger mr-2"></i>Error
                      </p>
                      <p>
                        {t(`errors.${error.error}`)}
                      </p>
                    </div>
                  ))
                }
                <hr />
              </Fragment>
            ))
          }
        </div>
      }
      footer={
        <BackBtn onClick={handleBack} label={t('form.exit')} />
      }
    />
  );
};

export default SuccessMultiple;
